<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <h2 class="section-title font-weight--bold mb-15">Refund Policy</h2>
      <hr class="my-4" />

      <div class="col-8" v-for="(refund, key) in refund" :key="key">
        <h5>{{ refund.title }}</h5>
        <p>{{ refund.body }}</p>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import refund from "../data/refundpolicy";

export default {
  components: {},

  data() {
    return {
      refund,
    };
  },
};
</script>
